export default __webpack_public_path__ + "bff812e.png";